import { BaseAbstractService } from "@common/service/base-service/global";
import RequestService from "@common/service/base-service/request/ICT2BRequest";
import { PubBiddingApi } from "@/zh-website/src/views/partner/api/pubBidding";

export class PubBiddingService extends BaseAbstractService {
  static getPubBiddingList(params) {
    return PubBiddingApi.getPubBiddingList(this.request, params);
  }
  static getPubBiddingDetail(params) {
    return PubBiddingApi.getPubBiddingDetail(this.request, params);
  }
  static getPubBiddingDetailFull(params) {
    return PubBiddingApi.getPubBiddingDetailFull(this.request, params);
  }
  static getPubBiddingCarousel(params) {
    return PubBiddingApi.getPubBiddingCarousel(this.request, params);
  }
  static getPubBiddingNumber() {
    return PubBiddingApi.getPubBiddingNumber(this.request);
  }
  static submitPubBiddingApply(params) {
    return PubBiddingApi.submitPubBiddingApply(this.request, params);
  }
  static downloadFile(query) {
    return PubBiddingApi.downloadFile(this.request, query);
  }
}
PubBiddingService.setRequest(RequestService);
